import React, { useEffect, useState } from "react";
import "@fortawesome/fontawesome-free/css/all.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/App.css";
import "./assets/css/Media.css";

import Header from "./component/Header";
import Footer from "./component/Footer";
import ScrollToTop from "./component/ScrollToTop";
import Home from "./pages/Home";
import PromoSlider from "./component/PromoSlider";
import Inquiry from "./pages/Inquiry";
import Faq from "./pages/Faq";
import About from "./pages/About";
import Privacy from "./pages/Privacy";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ToastContainer } from "react-toastify";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Http from "./helper/Http.js";

function App() {
  const [faq, setFaq] = useState("");
  const [privacyPolicy, setPrivacyPolicy] = useState("");
  const [about, setAbout] = useState("");
  const [news, setNews] = useState([]);
  const [imageUrl, setImageUrl] = useState("");
  const [videoData, setVideoData] = useState(null);
  const [videoBaseUrl, setVideoBaseUrl] = useState("");
  const [bannerData, setBannerData] = useState(null);
  const [frontServices, setFrontServices] = useState([]);
  const [frontServiceImageUrl, setFrontServiceImageUrl] = useState("");

  useEffect(() => {
    console.log("Testing purpose - 22-04-2026", process.env.REACT_APP_API_BASE_URL);
  }, []);

  const getData = async () => {
    let path = "admin/getContent";
    const res = await Http("GET", path);
    if (res) {
      const resJson = await res.json();
      if (res.status == 200) {
        return resJson;
      }
    }
  };

  const getNews = async () => {
    let path = "admin/getNews";
    const res = await Http("GET", path);
    if (res) {
      if (res.status == 200) {
        const resJson = await res.json();
        return resJson;
      }
    }
  };

  const getVideo = async () => {
    let path = "admin/getVideo";
    const res = await Http("GET", path);
    if (res) {
      if (res.status == 200) {
        const resJson = await res.json();
        return resJson;
      }
    }
  };
  const getSettings = async () => {
    let path = "admin/getAppVariablePublic";
    const res = await Http("GET", path);
    if (res) {
      if (res.status == 200) {
        const resJson = await res.json();
        return resJson;
      }
    }
  };

  const getFrontServices = async () => {
    let path = "admin/getFrontServicePublic";
    const res = await Http("GET", path);
    if (res) {
      if (res.status == 200) {
        const resJson = await res.json();
        return resJson;
      }
    }
  };

  useEffect(() => {
    getData().then((data) => {
      if (data?.result?.faq) {
        setFaq(data?.result?.faq);
      }
      if (data?.result?.privacy_policy) {
        setPrivacyPolicy(data?.result?.privacy_policy);
      }
      if (data?.result?.about_us) {
        setAbout(data?.result?.about_us);
      }
    });

    getNews().then((data) => {
      if (data?.result) {
        setNews(data?.result);
        setImageUrl(data?.image_url);
      }
    });

    getVideo().then((data) => {
      if (data?.success && data?.result) {
        setVideoData(data.result);
        let baseUrl = data.video_base_url || "";
        if (baseUrl.startsWith("undefined")) {
          baseUrl = baseUrl.replace(
            "undefined",
            process.env.REACT_APP_API_BASE_URL
          );
        }
        if (baseUrl && !baseUrl.endsWith("/")) {
          baseUrl += "/";
        }
        // Clean up double slashes like '//' in the path, but keep 'http://'
        baseUrl = baseUrl.replace(/([^:]\/)\/+/g, "$1");
        setVideoBaseUrl(baseUrl);
      }
    });

    getSettings().then((data) => {
      if (data?.result) {
        setBannerData(data.result);
      }
    });

    getFrontServices().then((data) => {
      if (data?.success && data?.result) {
        setFrontServices(data.result);
        setFrontServiceImageUrl(data.image_url);
      }
    });

    window.scrollTo(0, 0);
  }, []);

  return (
    <BrowserRouter>
      <ToastContainer />
      <Header />
      <PromoSlider news={news} imageUrl={imageUrl} />
      <ScrollToTop>
        <Switch>
          <Route exact path="/">
            <Home
              videoData={videoData}
              videoBaseUrl={videoBaseUrl}
              bannerData={bannerData}
              frontServices={frontServices}
              frontServiceImageUrl={frontServiceImageUrl}
            />
          </Route>
          <Route exact path="/about">
            <About data={about} />
          </Route>
          <Route exact path="/inquiry">
            <Inquiry />
          </Route>
          <Route exact path="/faq">
            <Faq data={faq} />
          </Route>
          <Route exact path="/privacy">
            <Privacy data={privacyPolicy} />
          </Route>
        </Switch>
      </ScrollToTop>

      <Footer />
    </BrowserRouter>
  );
}

export default App;
